import { __decorate } from "tslib";
import { Component, Mixins, Watch } from 'vue-property-decorator';
import { Getter, Mutation } from 'vuex-class';
import ViewportSizeMixin from '@/helpers/mixins/ViewportSizeMixin';
import RouterParamsAppMixin from '@/helpers/vue_mixins/RouterParamsAppMixin';
import FormValidationsMixin from '@/helpers/vue_mixins/v2/FormValidationsMixin';
import FormMixin from '@/helpers/vue_mixins/FormMixin';
import AlertMixin from '@/helpers/vue_mixins/AlertMixin';
import WindowSizeListener from '@/helpers/vue_mixins/v3/WindowSizeListenerMixin';
import BaseTextField from '@/components/v2/BaseTextField.vue';
import RadioBoxGroup from '@/views/v3/RadioBoxGroup.vue';
import ActionButton from '@/components/action_button/Index.vue';
import AdCampaigns from '@/plugins/graphql/queries/v3/ad-campaigns.gql';
import BaseOverlayLoader from '@/components/v2/BaseOverlayLoader';
import { requiredIf } from 'vuelidate/lib/validators';
import { requiredProperty } from '@/helpers/mixins/LocalizationHelper';
import CreateNewAdCampaign from '@/plugins/graphql/mutations/ads_manager/create-ad-campaign.gql';
import ConfirmationDialog from '@/components/ConfirmationDialog.vue';
let ComponentName = class ComponentName extends Mixins(ViewportSizeMixin, RouterParamsAppMixin, WindowSizeListener, FormValidationsMixin, Mixins(FormMixin, AlertMixin)) {
    constructor() {
        super(...arguments);
        this.adCampaigns = [];
        this.objectives = [
            { name: 'Sales', value: 'OUTCOME_SALES' },
            { name: 'Traffic', value: 'OUTCOME_TRAFFIC' },
        ];
        this.selectedOption = 1;
        this.options = [
            { value: 'Select Existing\nCampaign', index: 1 },
            { value: 'Create New\nCampaign', index: 2 },
        ];
        this.form = {
            adCampaign: null,
            // campaignType: '',
            campaignName: '',
            campaignObjective: { name: 'Traffic', value: 'OUTCOME_TRAFFIC' },
        };
        this.sending = false;
    }
    get containerHeight() {
        return {
            height: `${this.window.height * 0.6}px`,
        };
    }
    toggleConfirmation() {
        // this.selectedNotification = uuid;
        // this.$emit('selectDeleteUuid');
        this.showConfirmationDialog();
    }
    uponConfirm() {
        this.hideConfirmationDialog();
        this.$router.push({ name: 'ads-manager' });
    }
    async proceedToNext() {
        this.$v.$touch();
        if (!this.$v.$invalid) {
            if (this.selectedOption === 2) {
                this.sending = true;
                const mutation = () => this.createAdCampaign();
                await mutation()
                    .then(async ({ data }) => {
                    this.setAdCampaignId(data.createCampaign.campaignId);
                    this.sending = false;
                    this.$emit('proceedToNext');
                })
                    .catch((e) => {
                    this.errorNotification(e.message);
                    this.sending = false;
                });
            }
            else {
                this.$emit('proceedToNext');
            }
            this.setAdCampaignObjective(this.form.campaignObjective.value);
        }
    }
    hasId(obj) {
        if (obj?.id || this.selectedOption === 2) {
            return true;
        }
        return false;
    }
    get idErrors() {
        const errors = [];
        if (!this.$v.form.adCampaign.$dirty) {
            return errors;
        }
        if (!this.$v.form.adCampaign.required) {
            const msg = requiredProperty('Campaign');
            errors.push(msg);
        }
        if (!this.$v.form.adCampaign.invalidId) {
            const msg = 'Please Select an Ad Campaign From The List';
            errors.push(msg);
        }
        return errors;
    }
    onAdCampaignChange() {
        const vm = this;
        this.setAdCampaignId(vm.form.adCampaign?.id);
    }
    onCampaignObjectiveChange() {
        const vm = this;
        this.setAdCampaignObjective(vm.form.campaignObjective.value);
        vm.setCampaign();
    }
    async createAdCampaign() {
        const vm = this;
        const variables = {
            input: {
                appUuid: vm.appUUID,
                campaignName: vm.form.campaignName,
                adAccountId: vm.adAccountId,
                objective: vm.form.campaignObjective.value,
            },
        };
        return this.$apollo
            .mutate({
            mutation: CreateNewAdCampaign,
            variables,
        })
            .catch((e) => {
            console.error(e.message);
            this.errorNotification(e.message);
        });
    }
    get tooltipText() {
        if (this.adCampaignObjective === 'OUTCOME_SALES') {
            return `Only campaigns that are on and with the Sales campaign objective are shown here. If you can't find an existing campaign, it might be off or the campaign objective is not Sales`;
        }
        return `Only campaigns that are on and with the Traffic campaign objective are shown here. If you can't find an existing campaign, it might be off or the campaign objective is not Traffic`;
    }
    get objectiveDescription() {
        if (this.adCampaignObjective === 'OUTCOME_SALES') {
            return `Identify and engage with people who are most likely to purchase your products or services. Ideal for driving conversions, promoting catalog sales, initiating conversations on Messenger, Instagram, and WhatsApp, and generating calls.`;
        }
        return `Drive people to a specific destination, such as your website, mobile app, Instagram profile, or Facebook event. Ideal for generating link clicks, landing page visits, Instagram profile interactions, Messenger conversations, and calls.`;
    }
    setCampaignObjective() {
        if (this.adCampaignObjective === 'OUTCOME_SALES') {
            this.form.campaignObjective = { name: 'Sales', value: 'OUTCOME_SALES' };
        }
        else {
            this.form.campaignObjective = { name: 'Traffic', value: 'OUTCOME_TRAFFIC' };
        }
    }
    setCampaign() {
        this.form.adCampaign = null;
        this.$apollo.queries.adCampaigns.refetch().then(() => {
            if (this.adCampaignId) {
                const selectedAdCampaign = this.adCampaigns.filter((adCampaign) => {
                    return adCampaign.id === this.adCampaignId;
                });
                [this.form.adCampaign] = selectedAdCampaign;
            }
        });
    }
    async mounted() {
        await this.setCampaignObjective();
        await this.setCampaign();
    }
};
__decorate([
    Mutation('setAdCampaignId')
], ComponentName.prototype, "setAdCampaignId", void 0);
__decorate([
    Mutation('setAdCampaignObjective')
], ComponentName.prototype, "setAdCampaignObjective", void 0);
__decorate([
    Mutation('showConfirmationDialog')
], ComponentName.prototype, "showConfirmationDialog", void 0);
__decorate([
    Mutation('hideConfirmationDialog')
], ComponentName.prototype, "hideConfirmationDialog", void 0);
__decorate([
    Getter('adAccountId')
], ComponentName.prototype, "adAccountId", void 0);
__decorate([
    Getter('adCampaignObjective')
], ComponentName.prototype, "adCampaignObjective", void 0);
__decorate([
    Getter('adCampaignId')
], ComponentName.prototype, "adCampaignId", void 0);
__decorate([
    Watch('form.adCampaign')
], ComponentName.prototype, "onAdCampaignChange", null);
__decorate([
    Watch('form.campaignObjective')
], ComponentName.prototype, "onCampaignObjectiveChange", null);
ComponentName = __decorate([
    Component({
        components: {
            BaseTextField,
            RadioBoxGroup,
            ActionButton,
            ConfirmationDialog,
            BaseOverlayLoader,
        },
        apollo: {
            // Your component apollo queries here
            adCampaigns: {
                query: AdCampaigns,
                variables() {
                    return {
                        appUuid: this.$route.params.appUUID,
                        adAccountId: this.adAccountId,
                        objective: this.form.campaignObjective.value,
                    };
                },
                update(data) {
                    if (!data?.adCampaigns?.length) {
                        this.options = [{ value: 'Create New\nCampaign', index: 2 }];
                        this.selectedOption = 2;
                    }
                    else {
                        this.options = [
                            { value: 'Select Existing\nCampaign', index: 1 },
                            { value: 'Create New\nCampaign', index: 2 },
                        ];
                    }
                    return data.adCampaigns;
                },
            },
        },
        validations() {
            const vm = this;
            const selectCampaign = () => vm.selectedOption === 1;
            const newCampaign = () => vm.selectedOption === 2;
            const validations = {
                form: {
                    adCampaign: {
                        required: requiredIf(selectCampaign),
                        invalidId() {
                            const { adCampaign } = this.form;
                            return vm.hasId(adCampaign);
                        },
                    },
                    // campaignType: {
                    //   required: requiredIf(newCampaign),
                    // },
                    campaignName: {
                        required: requiredIf(newCampaign),
                    },
                    campaignObjective: {
                        required: requiredIf(newCampaign),
                    },
                },
            };
            return validations;
        },
    })
], ComponentName);
export default ComponentName;
